module.exports = __webpack_public_path__ + "img/digital_3.15725349.jpg";